export const TOGGLE_THEME = '@portal/TOGGLE_THEME';

export function toggleTheme() {
  return {
    type: TOGGLE_THEME,
    payload: {},
  };
}
